import React from 'react';
import {MasterLayout} from 'layout';
import {CanBoNhanKetQuaKiemTraDeXuat} from 'modules/reception';

export default class CanBoNhanKetQuaKiemTraDeXuatPage extends React.Component {

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
         <CanBoNhanKetQuaKiemTraDeXuat params={this.props.params} viewOnly={false}/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/reception/CanBoNhanKetQuaKiemTraDeXuatPage.jsx